<button class="btn btn-primary" [class]="styleClass" (click)="clicked.emit()" [disabled]="showSpinner || disableBtn">
  @if (showSpinner) {
    <i class="fa fa-spinner fa-spin"></i>
  }
  @if (!showSpinner && icon) {
    <i [class]="icon"></i>
  }
  {{ title }}
</button>
